module.exports = __webpack_public_path__ + "static/media/computer_find.09832444.ico";